(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-five-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tokio-collection-filter-grid')) {
    class CollectionFilterGrid extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('[data-filter-button]'));
        this.items = Array.from(this.querySelectorAll('[data-filter-item]'));
        this.emptyState = this.querySelector('[data-filter-empty]');
        this.onButtonClick = this.onButtonClick.bind(this);

        this.buttons.forEach((button) => {
          button.addEventListener('click', this.onButtonClick);
        });

        const initialFilter =
          this.querySelector('[data-filter-button].is-active')?.dataset.filter || 'all';

        this.applyFilter(initialFilter);
      }

      disconnectedCallback() {
        this.buttons?.forEach((button) => {
          button.removeEventListener('click', this.onButtonClick);
        });
      }

      onButtonClick(event) {
        this.applyFilter(event.currentTarget.dataset.filter || 'all');
      }

      applyFilter(filter) {
        const visibleProductIds = new Set();
        let visibleItems = 0;

        this.items.forEach((item) => {
          const belongsToFilter = filter === 'all' || item.dataset.filter === filter;
          const productId = item.dataset.productId;
          const isDuplicate = belongsToFilter && visibleProductIds.has(productId);
          const shouldShow = belongsToFilter && !isDuplicate;

          item.hidden = !shouldShow;

          if (shouldShow) {
            visibleProductIds.add(productId);
            visibleItems += 1;
          }
        });

        this.buttons.forEach((button) => {
          const isActive = button.dataset.filter === filter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', String(isActive));
        });

        if (this.emptyState) {
          this.emptyState.hidden = visibleItems > 0;
        }
      }
    }

    customElements.define('tokio-collection-filter-grid', CollectionFilterGrid);
  }

  } catch(e) { console.error(e); }
})();
})();
